<template>
  <div class="container">
    <div class="before-you-go-container">
      <span class="before-you-go">
        Before you go, consider these special offers:
      </span>
    </div>
    <div class="row">
      <div class="col-large-4">
        <div class="cancellation-options">
          <div class="cancellation-options-header">
            <label>Renew at a discounted Price</label>
          </div>
          <div class="cancellation-options-body most-popular-dc">
            <div class="insider-most-popular">
              <p class="most-popular-text">MOST POPULAR</p>
            </div>
            <ul class="cancellation-options-list">
              <li>
                Renew your annual subscription for only ${{
                  unsubscribe_promo_price
                }}
              </li>
              <li>${{ price }} for following years</li>
            </ul>
          </div>
          <div class="cancellation-submit">
            <a
              v-bind:class="
                has_used_datacast_promo ? 'button-grey' : 'button-green'
              "
              v-on:click="annualSubscription"
            >
              PURCHASE ANNUAL
            </a>
          </div>
        </div>
      </div>
      <div class="col-large-4">
        <div class="cancellation-options">
          <div class="cancellation-options-header">
            <label>Analyze Data for Less with DataCast Essentials™</label>
          </div>
          <div class="cancellation-options-body">
            <ul class="cancellation-options-list">
              <li>Unsubscribe from DataCast Pro subscription</li>
              <li>
                Sign up for DataCast Essentials at the low cost of ${{
                  datacast_essentials_price
                }}/month
              </li>
            </ul>
          </div>
          <div class="cancellation-submit">
            <a class="button-green" v-on:click="switchToEssentials">
              SWITCH TO ESSENTIALS
            </a>
          </div>
        </div>
      </div>
      <div class="col-large-4">
        <div class="cancellation-options">
          <div class="cancellation-options-header">
            <label>Don't Lose Access to the ITR Trends Report™</label>
          </div>
          <div class="cancellation-options-body-tr">
            <ul class="cancellation-options-list">
              <li>Unsubscribe from DataCast Pro subscription</li>
              <li>
                Keep your subscription to the
                <a target="_blank" href="/trendsreport">ITR Trends Report</a>
                (previously included in your DataCast Pro subscription)
              </li>
              <li>${{ trendsreport_price }} - renews annually</li>
            </ul>
          </div>
          <div class="cancellation-submit">
            <a
              v-bind:class="
                has_free_trendsreport ? 'button-green' : 'button-grey'
              "
              v-on:click="purchaseTrendsReport"
            >
              PURCHASE TRENDS REPORT
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'InsiderCancellationOptionsComponent',
    props: {
      product_to_unsubscribe: String,
      unsubscribe_promo_price: String,
      price: String,
      datacast_essentials_price: String,
      trendsreport_price: String,
      has_free_trendsreport: Boolean,
      has_used_datacast_promo: Boolean,
    },
    data: function () {
      return {
        iAgreeChecked: false,
      };
    },
    methods: {
      async annualSubscription() {
        if (this.has_used_datacast_promo) return;
        try {
          await axios.post(
            '/dashboard/cancelation/options/' + this.product_to_unsubscribe
          );
          window.location.href = '/dashboard/datacast-annual-subscription/';
        } catch (error) {
          window.location.href = '/dashboard/contact-customer-care-error/';
        }
      },
      async switchToEssentials() {
        try {
          await axios.post(
            '/dashboard/cancelation/options/switch-to-essentials/' +
              this.product_to_unsubscribe
          );
          window.location.href =
            '/dashboard/cancelation/options/switch-to-essentials/' +
            this.product_to_unsubscribe;
        } catch (error) {
          window.location.href = '/dashboard/contact-customer-care-error/';
        }
      },
      async purchaseTrendsReport() {
        if (!this.has_free_trendsreport) return;
        try {
          await axios.post(
            '/dashboard/cancelation/options/keep-trends-report/' +
              this.product_to_unsubscribe
          );
          window.location.href =
            '/dashboard/cancelation/options/keep-trends-report/' +
            this.product_to_unsubscribe;
        } catch (error) {
          window.location.href = '/dashboard/contact-customer-care-error/';
        }
      },
    },
  };
</script>
